import { useState } from 'react';
import { useAuth } from "../../context/AuthContext";

// styles
import * as S from './style';

// components
import CancelButton from '../../components/Button/CancelButton';
import ActionButton from '../../components/Button/ActionButton';

// icons
import { Warning } from '@phosphor-icons/react';


interface IModalProps {
  isOpen: boolean;
  setModalOpen: any;
}

export default function Logout({
  isOpen,
  setModalOpen,
}: IModalProps) {
  const [loading, setLoading] = useState(false);
  const { logout } = useAuth();
  
  const handleLogout = async () => {
    setLoading(true);
    await logout();
    setLoading(false);
  };

  if (isOpen) {
    return (
      <S.Container>
        <S.ContentModel>
          <S.InfoModel>
            <Warning size={48} weight="fill" />
            <div>
              <span>Tem certeza que deseja sair?</span>
              <small>Na próxima vez você deverá realizar seu login</small>
            </div>
          </S.InfoModel>
          
          <S.Action>
            <CancelButton name="Cancelar" onClick={() => setModalOpen(false)} />
            <ActionButton
              name={loading ? "Saindo..." : "Confirmar"}
              onClick={handleLogout}
            />
          </S.Action>
        </S.ContentModel>
      </S.Container>
    );
  }
  return null;
}
